import React from 'react';
import { format } from 'date-fns';
import Styled from 'styled-components';
import {
  FixedRightColumn,
  Headline,
  LayoutContainer,
  media,
  ResponsiveWideColumn,
  RowSpan,
} from '@amount/frontend-components';
import { Query } from 'react-apollo';

import { Loading } from '../Common/Spinner/LoadingHOC';
import ServerError from '../Common/Error/ServerError';
import { FlexColumn } from '../Common/CommonStyles';
import {
  BackgroundProviderBox,
  ContentPaddingContainerBox,
  MaxWidthContainerBox
} from '../Common/Box';

import GetCustomerHomeInformationQuery, {
  GetCustomerHomeInformation,
} from './queries/GetCustomerHomeInformation.graphql';
import GetCardServicingInformation, {
  GetCardServicingInformation as GetCardServicingInformationType
} from '../../g1/servicing/modules/CreditCard/queries/GetCardServicingInformation.graphql';
import CustomerHomeCards from './CustomerHomeCards';
import CrossSellOffers from './CrossSellOffers';

interface ICustomerHomeProps {
  data?: GetCustomerHomeInformation;
  complementaryData?: GetCardServicingInformationType,
  hasMultiProductEnabled?: boolean | null;
}

const RightColumn = Styled(FixedRightColumn)`

  ${media.mediumLarge`
    display: flex;
  `}
`;

const CustomerHomeCardsWrapper = Styled.div`
  ${media.medium`
    ${!AvantConfig.TenantConfig.customerHome.crossSellOffers && 'width: 675px;'} /* SHORT TERM SOLUTION */
  `}
`;

const GreetingHeadline = Styled(Headline)`
  margin-bottom: 0;
`;

export class CustomerHome extends React.PureComponent<ICustomerHomeProps> {
  public render () {
    const {
      data: { me } = { me: null },
      complementaryData
    } = this.props;

    if (!me) {
      return <ServerError />;
    }

    const extendedMe = {...me, hasMultiProductEnabled: complementaryData?.me?.hasMultiProductEnabled}

    return (
      <BackgroundProviderBox>
        <MaxWidthContainerBox>
          <ContentPaddingContainerBox>
            <RowSpan>
              {!!(me && me.firstName) && (
                <GreetingHeadline scale='large' as='h1'>
                  Hello, {me.firstName}
                </GreetingHeadline>
              )}
              {AvantConfig.TenantConfig.customerHome.showDate && (
                <span data-test-hidden={true}>Today is {format(new Date(), 'dddd, MMMM Do, YYYY')}.</span>
              )}
            </RowSpan>
              <LayoutContainer>
                <ResponsiveWideColumn>
                  <FlexColumn>
                    <CustomerHomeCardsWrapper>
                      <CustomerHomeCards {...extendedMe} />
                    </CustomerHomeCardsWrapper>
                  </FlexColumn>
                </ResponsiveWideColumn>
                <RightColumn>
                  <CrossSellOffers crossSellInformation={me.crossSellInformation || []} />
                </RightColumn>
              </LayoutContainer>
          </ContentPaddingContainerBox>
        </MaxWidthContainerBox>
      </BackgroundProviderBox>
    );
  }
}

const LiftedCustomerHome: React.FunctionComponent<ICustomerHomeProps> = props => (
  <Query<GetCustomerHomeInformation>
  query={GetCustomerHomeInformationQuery}
  fetchPolicy='cache-and-network'
  >
    {({ data: homeData, loading: homeLoading }) => (
      <Loading loading={homeLoading}>
        {homeData && (
          <Query<GetCardServicingInformationType>
            query={GetCardServicingInformation}
            variables={{ uuid: homeData.me?.id }}
            fetchPolicy='cache-and-network'
          >
            {({ data: complementaryData, loading: complementaryDataLoading }) => (
              <Loading loading={complementaryDataLoading}>
                <CustomerHome data={homeData} complementaryData={complementaryData} {...props} />
              </Loading>
            )}
          </Query>
        )}
      </Loading>
    )}
  </Query>
);

export default LiftedCustomerHome;
